module.exports = __webpack_public_path__ + "static/media/gamepad-alt.e0e1b335.svg";